<template>
  <div class="TutorProfile">

    <h1 class="m-label" style="margin: 0">
      先生基本情報
    </h1>

    <template v-if="tutor.id == edit_id.tutor_id">
      <form @submit.prevent="patchTutor(tutor)">
        <div class="m-box__inner">
          <table class="m-detail">
            <template v-if="!valid">
              <tr>
                <th>エラー</th>
                <td class="errors"><div>{{errors}}が入力されていません</div></td>
              </tr>
            </template>
            <tr>
              <th>ID</th>
              <td><div class="calc">{{tutor.id}}</div></td>
            </tr>
            <tr>
              <th>user_id</th>
              <td><div class="calc">{{tutor.user_id}}</div></td>
            </tr>
            <tr>
              <th>営業所</th>
              <td><multiselect v-model="watch.office_id" :options="offices" label="name" :searchable="false" :show-labels="false" placeholder="営業所"></multiselect></td>
            </tr>
            <tr>
              <th class="req">状態</th>
              <td class="checkbox">
                <div>
                  <label for="state_0">未選択</label>
                  <input type="radio" name="state" required id="state_0" value="0" v-model="tutor.state" @keypress.self.prevent.13>
                  <label for="state_1">指導可能</label>
                  <input type="radio" name="state" id="state_1" value="1" v-model="tutor.state" @keypress.self.prevent.13>
                  <label for="state_2">指導不可</label>
                  <input type="radio" name="state" id="state_2" value="2" v-model="tutor.state" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>登録日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="tutor.registration_date" placeholder="登録日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>名前</th>
              <td><input type="text" class="name_w" v-model="tutor.f_name" @keypress.self.prevent.13><input type="text" class="name_w" v-model="tutor.l_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">かな</th>
              <td><input type="text" required class="name_w" v-model="tutor.f_name_kana" @keypress.self.prevent.13><input type="text" required class="name_w" v-model="tutor.l_name_kana" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>性別</th>
              <td class="checkbox">
                <div>
                  <label for="gender_0">未選択</label>
                  <input type="radio" id="gender_0" value="0" v-model="tutor.gender" @keypress.self.prevent.13>
                  <label for="gender_1">男</label>
                  <input type="radio" id="gender_1" value="1" v-model="tutor.gender" @keypress.self.prevent.13>
                  <label for="gender_2">女</label>
                  <input type="radio" id="gender_2" value="2" v-model="tutor.gender" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>生年月日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="tutor.birthday" placeholder="生年月日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>年齢</th>
              <td><div class="calc">{{calcAge}}</div></td>
            </tr>
            <tr>
              <th>郵便番号</th>
              <td><input type="text" v-model="tutor.zip" @keyup="getYubin" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">都道府県</th>
              <td><multiselect v-model="watch.pref" :options="prefs" label="name" :searchable="true" :show-labels="false" placeholder="都道府県"></multiselect></td>
            </tr>
            <tr>
              <th class="req">市区町村・番地</th>
              <td><input type="text" required v-model="tutor.address1" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>建物名・部屋番号</th>
              <td><input type="text" v-model="tutor.address2" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th cllass="req">携帯TEL</th>
              <td><input type='text' required maxlength="11" minlength="10" v-model="tutor.tel1" placeholder="携帯TEL" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>固定TEL</th>
              <td><input type='text' maxlength="11" minlength="10" v-model="tutor.tel2" placeholder="固定TEL" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>MAIL1</th>
              <td><input type="text" v-model="tutor.mail1" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>MAIL2</th>
              <td><input type="text" v-model="tutor.mail2" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>実家郵便番号</th>
              <td><input type="text" v-model="tutor.home_zip" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>実家/都道府県</th>
              <td><multiselect v-model="watch.home_pref" :options="prefs" label="name" :searchable="true" :show-labels="false" placeholder="実家/都道府県"></multiselect></td>
            </tr>
            <tr>
              <th>実家/市区町村・番地</th>
              <td><input type="text" v-model="tutor.home_address1" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>実家/建物名・部屋番号</th>
              <td><input type="text" v-model="tutor.home_address2" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>実家TEL</th>
              <td><input type='text' maxlength="11" minlength="10" v-model="tutor.home_tel" placeholder="実家TEL" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>学校名</th>
              <td><input type="text" v-model="tutor.school_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">区分</th>
              <td><multiselect v-model="watch.school_stage" :options="school_stage" label="name" :searchable="false" :show-labels="false" placeholder="区分"></multiselect></td>
            </tr>
            <tr>
              <th>学部</th>
              <td><input type="text" v-model="tutor.department" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>旧学年</th>
              <td><multiselect v-model="watch.old_grade" :options="old_grade" label="name" :searchable="false" :show-labels="false" placeholder="旧学年"></multiselect></td>
            </tr>
            <tr>
              <th>学年</th>
              <td><div class="calc">{{calcGrade}}</div></td>
            </tr>
            <tr>
              <th>留年・浪人</th>
              <td><input type="number" v-model="tutor.grade_flag" placeholder="留年・浪人" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>文系/理系</th>
              <td class="checkbox">
                <div>
                  <label for="department_type_0">未選択</label>
                  <input type="radio" id="department_type_0" value="0" v-model="tutor.department_type" @keypress.self.prevent.13>
                  <label for="department_type_1">文系</label>
                  <input type="radio" id="department_type_1" value="1" v-model="tutor.department_type" @keypress.self.prevent.13>
                  <label for="department_type_2">理系</label>
                  <input type="radio" id="department_type_2" value="2" v-model="tutor.department_type" @keypress.self.prevent.13>
                  <label for="department_type_3">他</label>
                  <input type="radio" id="department_type_3" value="3" v-model="tutor.department_type" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>サークル</th>
              <td><input type="text" v-model="tutor.club" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>高校部活</th>
              <td><input type="text" v-model="tutor.high_school_club" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>出身高校</th>
              <td><input type="text" v-model="tutor.high_school_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>移動手段</th>
              <td class="checkbox">
                <div>
                  <label for="car">車</label>
                  <input type="checkbox" id="car" v-model="watch.transportation_car" @keypress.self.prevent.13>
                  <label for="bike">バイク</label>
                  <input type="checkbox" id="bike" v-model="watch.transportation_bike" @keypress.self.prevent.13>
                  <label for="scooters">原付</label>
                  <input type="checkbox" id="scooters" v-model="watch.transportation_scooters" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="bicycle">自転車</label>
                  <input type="checkbox" id="bicycle" v-model="watch.transportation_bicycle" @keypress.self.prevent.13>
                  <label for="train">電車</label>
                  <input type="checkbox" id="train" v-model="watch.transportation_train" @keypress.self.prevent.13>
                  <label for="none">無し</label>
                  <input type="checkbox" id="none" v-model="watch.transportation_none" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>最寄駅</th>
              <td><input type="text" v-model="tutor.nearest_station" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>受験経験</th>
              <td class="checkbox">
                <div>
                  <label for="exam_s">小学</label>
                  <input type="checkbox" id="exam_s" v-model="watch.exam_s" @keypress.self.prevent.13>
                  <label for="exam_c">中学</label>
                  <input type="checkbox" id="exam_c" v-model="watch.exam_c" @keypress.self.prevent.13>
                  <label for="exam_k">高校</label>
                  <input type="checkbox" id="exam_k" v-model="watch.exam_k" @keypress.self.prevent.13>
                  <label for="exam_d">大学</label>
                  <input type="checkbox" id="exam_d" v-model="watch.exam_d" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>家教・塾講経験</th>
              <td class="checkbox">
                <div>
                  <label for="experience_tutor">家庭教師</label>
                  <input type="checkbox" id="experience_tutor" v-model="watch.experience_tutor" @keypress.self.prevent.13>
                  <label for="experience_cram">塾講師</label>
                  <input type="checkbox" id="experience_cram" v-model="watch.experience_cram" @keypress.self.prevent.13>
                  <label for="experience_none">無し</label>
                  <input type="checkbox" id="experience_none" v-model="watch.experience_none" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>備考(家教経験)</th>
              <td><input type="text" v-model="tutor.experience_tutor_note" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>備考(塾講経験)</th>
              <td><input type="text" v-model="tutor.experience_cram_note" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th style="background: #eee">登録媒体</th>
              <td style="background: #eee">{{tutor.medium}}</td>
            </tr>
            <tr>
              <th>備考(登録媒体)</th>
              <td><input type="text" v-model="tutor.medium_note" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>HP/パンフ掲載</th>
              <td class="checkbox">
                <div>
                  <label for="published_0">未選択</label>
                  <input type="radio" id="published_0" value="0" v-model="tutor.published" @keypress.self.prevent.13>
                  <label for="published_1">OK</label>
                  <input type="radio" id="published_1" value="1" v-model="tutor.published" @keypress.self.prevent.13>
                  <label for="published_2">NG</label>
                  <input type="radio" id="published_2" value="2" v-model="tutor.published" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th class="req">情報発信</th>
              <td class="checkbox">
                <div>
                  <label for="information_0">未選択</label>
                  <input type="radio" name="information" required id="information_0" value="0" v-model="tutor.information" @keypress.self.prevent.13>
                  <label for="information_1">OK</label>
                  <input type="radio" name="information" id="information_1" value="1" v-model="tutor.information" @keypress.self.prevent.13>
                  <label for="information_2">NG</label>
                  <input type="radio" name="information" id="information_2" value="2" v-model="tutor.information" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>印象ランク</th>
              <td class="checkbox">
                <div>
                  <label for="impression_0">未選択</label>
                  <input type="radio" id="impression_0" value="0" v-model="tutor.impression" @keypress.self.prevent.13>
                </div>
                <div>
                  <label for="impression_1">AA</label>
                  <input type="radio" id="impression_1" value="1" v-model="tutor.impression" @keypress.self.prevent.13>
                  <label for="impression_2">A</label>
                  <input type="radio" id="impression_2" value="2" v-model="tutor.impression" @keypress.self.prevent.13>
                  <label for="impression_3">B</label>
                  <input type="radio" id="impression_3" value="3" v-model="tutor.impression" @keypress.self.prevent.13>
                  <label for="impression_4">C</label>
                  <input type="radio" id="impression_4" value="4" v-model="tutor.impression" @keypress.self.prevent.13>
                  <label for="impression_5">Z</label>
                  <input type="radio" id="impression_5" value="5" v-model="tutor.impression" @keypress.self.prevent.13>
                  <label for="impression_6">紹介不可</label>
                  <input type="radio" id="impression_6" value="6" v-model="tutor.impression" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>印象ランク備考</th>
              <td><textarea v-model="tutor.impression_note"></textarea></td>
            </tr>
            <tr>
              <th>研修</th>
              <td class="checkbox">
                <div>
                  <label for="training">研修</label>
                  <input type="checkbox" id="training" v-model="watch.training" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>研修備考</th>
              <td><textarea v-model="tutor.training_note"></textarea></td>
            </tr>
            <tr>
              <th>SSK</th>
              <td class="checkbox">
                <div>
                  <label for="ssk">SSK</label>
                  <input type="checkbox" id="ssk" v-model="watch.ssk" @keypress.self.prevent.13>
                </div>
              </td>
            </tr>
            <tr>
              <th>備考</th>
              <td><textarea v-model="tutor.note"></textarea></td>
            </tr>
          </table>
        </div>

        <div style="display: flex">
          <btn class="m-btn m-btn--default"><i class="fa fa-pencil-square-o"></i>更新</btn>
          <btn class="m-btn m-btn--default cancel" type="button" @click.native.prevent="cancelTutor(tutor)"><i class="fa fa-pencil-square-o"></i>キャンセル</btn>
        </div>

      </form>
    </template>

    <template v-if="tutor.id !== edit_id.tutor_id">
      <div class="m-box__inner">
        <table class="m-detail">
          <template v-if="!valid">
            <tr>
              <th>エラー</th>
              <td class="errors"><div>{{errors}}が入力されていません</div></td>
            </tr>
          </template>
          <tr>
            <th>ID</th>
            <td>{{tutor.id}}</td>
          </tr>
          <tr>
            <th>user_id</th>
            <td>{{tutor.user_id}}</td>
          </tr>
          <tr>
            <th>営業所</th>
            <template v-if="tutor.office_id">
              <td>{{officeName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>状態</th>
            <td v-if="tutor.state === 0">未選択</td>
            <td v-if="tutor.state === 1">指導可</td>
            <td v-if="tutor.state === 2">指導不可</td>
          </tr>
          <tr>
            <th>登録日</th>
            <td>{{tutor.registration_date}}</td>
          </tr>
          <tr>
            <th>名前</th>
            <td>{{tutor.f_name}} {{tutor.l_name}}</td>
          </tr>
          <tr>
            <th>かな</th>
            <td>{{tutor.f_name_kana}} {{tutor.l_name_kana}}</td>
          </tr>
          <tr>
            <th>性別</th>
            <td v-if="tutor.gender === 0">未選択</td>
            <td v-if="tutor.gender === 1">男</td>
            <td v-if="tutor.gender === 2">女</td>
          </tr>
          <tr>
            <th>生年月日</th>
            <td>{{tutor.birthday}}</td>
          </tr>
          <tr>
            <th>年齢</th>
            <td>{{calcAge}}</td>
          </tr>
          <tr>
            <th>郵便番号</th>
            <td>{{tutor.zip}}</td>
          </tr>
          <tr>
            <th>都道府県</th>
            <template v-if="tutor.pref">
              <td>{{prefName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>市区町村・番地</th>
            <td>{{tutor.address1}}</td>
          </tr>
          <tr>
            <th>建物名・部屋番号</th>
            <td>{{tutor.address2}}</td>
          </tr>
          <tr>
            <th>携帯TEL</th>
            <td>{{tutor.tel1}}</td>
          </tr>
          <tr>
            <th>固定TEL</th>
            <td>{{tutor.tel2}}</td>
          </tr>
          <tr>
            <th>MAIL1</th>
            <td>{{tutor.mail1}}</td>
          </tr>
          <tr>
            <th>MAIL2</th>
            <td>{{tutor.mail2}}</td>
          </tr>
          <tr>
            <th>実家郵便番号</th>
            <td style="color: #999">{{tutor.home_zip}}</td>
          </tr>
          <tr>
            <th>実家/都道府県</th>
            <template v-if="tutor.home_pref">
              <td style="color: #999">{{homePrefName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>実家/市区町村・番地</th>
            <td style="color: #999">{{tutor.home_address1}}</td>
          </tr>
          <tr>
            <th>実家/建物名・部屋番号</th>
            <td style="color: #999">{{tutor.home_address2}}</td>
          </tr>
          <tr>
            <th>実家TEL</th>
            <td style="color: #999">{{tutor.home_tel}}</td>
          </tr>
          <tr>
            <th>学校名</th>
            <td>{{tutor.school_name}}</td>
          </tr>
          <tr>
            <th>区分</th>
            <td v-if="tutor.school_stage === 0">未選択</td>
            <td v-if="tutor.school_stage === 1">大学4年制</td>
            <td v-if="tutor.school_stage === 2">大学院</td>
            <td v-if="tutor.school_stage === 3">専門2年制</td>
            <td v-if="tutor.school_stage === 4">高校</td>
            <td v-if="tutor.school_stage === 5">大学6年制</td>
            <td v-if="tutor.school_stage === 6">専門3年制</td>
            <td v-if="tutor.school_stage === 7">短大2年制</td>
            <td v-if="tutor.school_stage === 8">高専</td>
            <td v-if="tutor.school_stage === 9">大学</td>
            <td v-if="tutor.school_stage === 10">専門</td>
          </tr>
          <tr>
            <th>学部</th>
            <td>{{tutor.department}}</td>
          </tr>
          <tr>
            <th>旧学年</th>
            <td v-if="tutor.old_grade === 0">未選択</td>
            <td v-if="tutor.old_grade === 1">1</td>
            <td v-if="tutor.old_grade === 2">2</td>
            <td v-if="tutor.old_grade === 3">3</td>
            <td v-if="tutor.old_grade === 4">4</td>
            <td v-if="tutor.old_grade === 5">5</td>
            <td v-if="tutor.old_grade === 6">6</td>
            <td v-if="tutor.old_grade === 7">M1</td>
            <td v-if="tutor.old_grade === 8">M2</td>
            <td v-if="tutor.old_grade === 9">D1</td>
            <td v-if="tutor.old_grade === 10">D2</td>
            <td v-if="tutor.old_grade === 11">卒業</td>
            <td v-if="tutor.old_grade === 12">中退</td>
          </tr>
          <tr>
            <th>学年</th>
            <td>{{calcGrade}}</td>
          </tr>
          <tr>
            <th>留年・浪人</th>
            <td>{{tutor.grade_flag}}</td>
          </tr>
          <tr>
            <th>文系/理系</th>
            <td v-if="tutor.department_type === 0">未選択</td>
            <td v-if="tutor.department_type === 1">文系</td>
            <td v-if="tutor.department_type === 2">理系</td>
            <td v-if="tutor.department_type === 3">他</td>
          </tr>
          <tr>
            <th>サークル</th>
            <td>{{tutor.club}}</td>
          </tr>
          <tr>
            <th>高校部活</th>
            <td>{{tutor.high_school_club}}</td>
          </tr>
          <tr>
            <th>出身高校</th>
            <td>{{tutor.high_school_name}}</td>
          </tr>
          <tr>
            <th>移動手段</th>
            <td>
              <span v-for="(list, index) in transportations" :key="index.id">{{list}} </span>
            </td>
          </tr>
          <tr>
            <th>最寄駅</th>
            <td>{{tutor.nearest_station}}</td>
          </tr>
          <tr>
            <th>受験経験</th>
            <td>
              <span v-for="(list, index) in exams" :key="index.id">{{list}} </span>
            </td>
          </tr>
          <tr>
            <th>指導経験</th>
            <td>
              <span v-for="(list, index) in experiences" :key="index.id">{{list}} </span>
            </td>
          </tr>
          <tr>
            <th>備考(家庭教師経験)</th>
            <td>{{tutor.experience_tutor_note}}</td>
          </tr>
          <tr>
            <th>備考(塾講師経験)</th>
            <td>{{tutor.experience_cram_note}}</td>
          </tr>
          <tr>
            <th style="background: #eee">登録媒体</th>
            <td style="background: #eee">{{tutor.medium}}</td>
          </tr>
          <tr>
            <th>備考(登録媒体)</th>
            <td>{{tutor.medium_note}}</td>
          </tr>
          <tr>
            <th>HP/パンフ掲載</th>
            <td v-if="tutor.published === 0">未選択</td>
            <td v-if="tutor.published === 1">OK</td>
            <td v-if="tutor.published === 2">NG</td>
          </tr>
          <tr>
            <th>情報発信</th>
            <td v-if="tutor.information === 0">未選択</td>
            <td v-if="tutor.information === 1">OK</td>
            <td v-if="tutor.information === 2">NG</td>
          </tr>
          <tr>
            <th>印象ランク</th>
            <td v-if="tutor.impression === 0">未選択</td>
            <td v-if="tutor.impression === 1">AA</td>
            <td v-if="tutor.impression === 2">A</td>
            <td v-if="tutor.impression === 3">B</td>
            <td v-if="tutor.impression === 4">C</td>
            <td v-if="tutor.impression === 5">Z</td>
            <td v-if="tutor.impression === 6">紹介不可</td>
          </tr>
          <tr>
            <th>印象ランク備考</th>
            <td>{{tutor.impression_note}}</td>
          </tr>
          <tr>
            <th>研修</th>
            <td v-if="tutor.training === 0">未</td>
            <td v-if="tutor.training === 1">済</td>
          </tr>
          <tr>
            <th>研修備考</th>
            <td style="white-space: pre-wrap">{{tutor.training_note}}</td>
          </tr>
          <tr>
            <th>SSK</th>
            <td v-if="tutor.ssk === 0">未</td>
            <td v-if="tutor.ssk === 1">済</td>
          </tr>
          <tr>
            <th>備考</th>
            <td style="white-space: pre-wrap">{{tutor.note}}</td>
          </tr>
        </table>
      </div>
      <btn @click.native="edit(tutor)"><i class="fa fa-pencil-square-o"></i>編集</btn>
    </template>
  </div>
</template>

<script>
let jsonp = require('jsonp')
export default {
  props: {
    tutor: Object,
    edit_id: Object
  },
  data () {
    return {
      geometry: '',
      watch: {
        office_id: '',
        pref: '',
        home_pref: '',
        old_grade: '',
        school_stage: '',
        transportation_car: '',
        transportation_bike: '',
        transportation_scooters: '',
        transportation_bicycle: '',
        transportation_train: '',
        transportation_none: '',
        exam_s: '',
        exam_c: '',
        exam_k: '',
        exam_d: '',
        experience_tutor: '',
        experience_cram: '',
        experience_none: '',
        training: '',
        ssk: ''
      },
      // state: [
      //   { name: '未選択', value: 0 },
      //   { name: '指導可能', value: 1 },
      //   { name: '指導不可', value: 2 }
      // ],
      // gender: [
      //   { name: '未選択', value: 0 },
      //   { name: '男', value: 1 },
      //   { name: '女', value: 2 }
      // ],
      old_grade: [
        { name: '未選択', value: 0 },
        { name: '1', value: 1 },
        { name: '2', value: 2 },
        { name: '3', value: 3 },
        { name: '4', value: 4 },
        { name: '5', value: 5 },
        { name: '6', value: 6 },
        { name: 'M1', value: 7 },
        { name: 'M2', value: 8 },
        { name: 'D1', value: 9 },
        { name: 'D2', value: 10 },
        { name: '卒業', value: 11 },
        { name: '中退', value: 12 }
      ],
      school_stage: [
        { name: '未選択', value: 0 },
        { name: '大学4年制', value: 1 },
        { name: '大学院', value: 2 },
        { name: '専門2年制', value: 3 },
        { name: '高校', value: 4 },
        { name: '大学6年制', value: 5 },
        { name: '専門3年制', value: 6 },
        { name: '短大2年制', value: 7 },
        { name: '高専', value: 8 },
        { name: '大学', value: 9 },
        { name: '専門', value: 10 },
        { name: '博士課程', value: 11 }
      ]
    }
  },
  computed: {
    offices () {
      return this.$store.getters.offices
    },

    prefs () {
      return this.$store.getters.prefs
    },

    officeName () {
      return this.offices.filter(office => {
        return office.id === this.tutor.office_id
      })[0].name
    },

    prefName () {
      return this.prefs.filter(pref => {
        return pref.id === this.tutor.pref
      })[0].name
    },

    homePrefName () {
      return this.prefs.filter(pref => {
        return pref.id === this.tutor.home_pref
      })[0].name
    },

    // validation
    registration_dateErrors: function () {
      return this.tutor.registration_date ? [] : ['登録日']
    },
    f_name_kanaErrors: function () {
      return this.tutor.f_name_kana ? [] : ['せい']
    },
    l_name_kanaErrors: function () {
      return this.tutor.l_name_kana ? [] : ['めい']
    },
    birthdayErrors: function () {
      return this.tutor.birthday ? [] : ['生年月日']
    },
    prefErrors: function () {
      return this.tutor.pref ? [] : ['都道府県']
    },
    address1Errors: function () {
      return this.tutor.address1 ? [] : ['住所(市区町村・番地)']
    },
    tel1Errors: function () {
      return this.tutor.tel1 ? [] : ['携帯TEL']
    },
    school_stageErrors: function () {
      return this.tutor.school_stage ? [] : ['区分']
    },

    errors: function () {
      let errors = [].concat(
        this.registration_dateErrors,
        this.f_name_kanaErrors,
        this.l_name_kanaErrors,
        this.birthdayErrors,
        this.prefErrors,
        this.address1Errors,
        this.tel1Errors,
        this.school_stageErrors
      )
      let errorsJoin = errors.join('・')
      return errorsJoin
    },
    valid: function () {
      return !this.errors
    },

    transportations: function () {
      let self = this
      let arr = []
      if (self.tutor.transportation_car) {
        arr.push('車')
      }
      if (self.tutor.transportation_bike) {
        arr.push('バイク')
      }
      if (self.tutor.transportation_scooters) {
        arr.push('原付')
      }
      if (self.tutor.transportation_bicycle) {
        arr.push('自転車')
      }
      if (self.tutor.transportation_train) {
        arr.push('電車')
      }
      if (self.tutor.transportation_none) {
        arr.push('無し')
      }
      return arr
    },

    exams: function () {
      let self = this
      let arr = []
      if (self.tutor.exam_s) {
        arr.push('小学')
      }
      if (self.tutor.exam_c) {
        arr.push('中学')
      }
      if (self.tutor.exam_k) {
        arr.push('高校')
      }
      if (self.tutor.exam_d) {
        arr.push('大学')
      }
      return arr
    },

    experiences: function () {
      let self = this
      let arr = []
      if (self.tutor.experience_tutor) {
        arr.push('家庭教師')
      }
      if (self.tutor.experience_cram) {
        arr.push('塾講師')
      }
      if (self.tutor.experience_none) {
        arr.push('無し')
      }
      return arr
    },

    // age計算
    calcAge: function () {
      // console.log(this.tutor.birthday)
      let x = Date.parse(this.tutor.birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade: function () {
      let self = this

      // console.log(self.tutor.birthday)
      let x = Date.parse(self.tutor.birthday) // 変換(ミリ秒が返される)
      // console.log(x)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す
      // console.log(birthdate)

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }
      // console.log(year)

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      // // 月だけ0から始まるので4月は3
      // let ageNumber
      // // 幼稚園年少 4年前/04/02-3年前/04/01
      // if (birthdate >= new Date(year - 4, 3, 2) && birthdate <= new Date(year - 3, 3, 1, 23, 59)) {
      //   ageNumber = 4
      //
      // // 幼稚園年中 5年前/04/02-4年前/04/01
      // } else if (birthdate >= new Date(year - 5, 3, 2) && birthdate <= new Date(year - 4, 3, 1, 23, 59)) {
      //   ageNumber = 5
      //
      // // 幼稚園年長 6年前/04/02-5年前/04/01
      // } else if (birthdate >= new Date(year - 6, 3, 2) && birthdate <= new Date(year - 5, 3, 1, 23, 59)) {
      //   ageNumber = 6
      //
      // // 小学1年生 7年前/04/02-6年前/04/01
      // } else if (birthdate >= new Date(year - 7, 3, 2) && birthdate <= new Date(year - 6, 3, 1, 23, 59)) {
      //   ageNumber = 7
      //
      // // 小学2年生 2009/04/02-2010/04/01
      // } else if (birthdate >= new Date(year - 8, 3, 2) && birthdate <= new Date(year - 7, 3, 1, 23, 59)) {
      //   ageNumber = 8
      //
      // // 小学3年生 2008/04/02-2009/04/01
      // } else if (birthdate >= new Date(year - 9, 3, 2) && birthdate <= new Date(year - 8, 3, 1, 23, 59)) {
      //   ageNumber = 9
      //
      // // 小学4年生 2007/04/02-2008/04/01
      // } else if (birthdate >= new Date(year - 10, 3, 2) && birthdate <= new Date(year - 9, 3, 1, 23, 59)) {
      //   ageNumber = 10
      //
      // // 小学5年生 2006/04/02-2007/04/01
      // } else if (birthdate >= new Date(year - 11, 3, 2) && birthdate <= new Date(year - 10, 3, 1, 23, 59)) {
      //   ageNumber = 11
      //
      // // 小学6年生 2005/04/02-2006/04/01
      // } else if (birthdate >= new Date(year - 12, 3, 2) && birthdate <= new Date(year - 11, 3, 1, 23, 59)) {
      //   ageNumber = 12
      //
      // // 中学1年生 2004/04/02-2005/04/01
      // } else if (birthdate >= new Date(year - 13, 3, 2) && birthdate <= new Date(year - 12, 3, 1, 23, 59)) {
      //   ageNumber = 13
      //
      // // 中学2年生 2003/04/02-2004/04/01
      // } else if (birthdate >= new Date(year - 14, 3, 2) && birthdate <= new Date(year - 13, 3, 1, 23, 59)) {
      //   ageNumber = 14
      //
      // // 中学3年生 2002/04/02-2003/04/01
      // } else if (birthdate >= new Date(year - 15, 3, 2) && birthdate <= new Date(year - 14, 3, 1, 23, 59)) {
      //   ageNumber = 15
      //
      // // 高校1年生 2001/04/02-2002/04/01
      // } else if (birthdate >= new Date(year - 16, 3, 2) && birthdate <= new Date(year - 15, 3, 1, 23, 59)) {
      //   ageNumber = 16
      //
      // // 高校2年生 2000/04/02-2001/04/01
      // } else if (birthdate >= new Date(year - 17, 3, 2) && birthdate <= new Date(year - 16, 3, 1, 23, 59)) {
      //   ageNumber = 17
      //
      // // 高校3年生 1999/04/02-2000/04/01
      // } else if (birthdate >= new Date(year - 18, 3, 2) && birthdate <= new Date(year - 17, 3, 1, 23, 59)) {
      //   ageNumber = 18
      //
      // // 大学1年生 1998/04/02-1999/04/01
      // } else if (birthdate >= new Date(year - 19, 3, 2) && birthdate <= new Date(year - 18, 3, 1, 23, 59)) {
      //   ageNumber = 19
      //
      // // 大学2年生 1997/04/02-1998/04/01
      // } else if (birthdate >= new Date(year - 20, 3, 2) && birthdate <= new Date(year - 19, 3, 1, 23, 59)) {
      //   ageNumber = 20
      //
      // // 大学3年生 1996/04/02-1997/04/01
      // } else if (birthdate >= new Date(year - 21, 3, 2) && birthdate <= new Date(year - 20, 3, 1, 23, 59)) {
      //   ageNumber = 21
      //
      // // 大学4年生 1995/04/02-1996/04/01
      // } else if (birthdate >= new Date(year - 22, 3, 2) && birthdate <= new Date(year - 21, 3, 1, 23, 59)) {
      //   ageNumber = 22
      //
      // // 大学5年生 1994/04/02-1995/04/01
      // } else if (birthdate >= new Date(year - 23, 3, 2) && birthdate <= new Date(year - 22, 3, 1, 23, 59)) {
      //   ageNumber = 23
      //
      // // 大学6年生 1994/04/02-1995/04/01
      // } else if (birthdate >= new Date(year - 24, 3, 2) && birthdate <= new Date(year - 23, 3, 1, 23, 59)) {
      //   ageNumber = 24
      //
      // // 未該当
      // } else {
      //   ageNumber = 0
      // }

      let gradeNumber = ageNumber + Number(self.tutor.grade_flag)
      // console.log(ageNumber)
      // console.log(gradeNumber)

      // 月だけ0から始まるので4月は3
      let grade
      // 幼稚園年少 4年前/04/02-3年前/04/01
      if (gradeNumber === 4) {
        grade = '幼稚園年少'

      // 幼稚園年中 5年前/04/02-4年前/04/01
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'

      // 幼稚園年長 6年前/04/02-5年前/04/01
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'

      // 小学1年生 7年前/04/02-6年前/04/01
      } else if (gradeNumber === 7) {
        grade = '小学1年生'

      // 小学2年生 2009/04/02-2010/04/01
      } else if (gradeNumber === 8) {
        grade = '小学2年生'

      // 小学3年生 2008/04/02-2009/04/01
      } else if (gradeNumber === 9) {
        grade = '小学3年生'

      // 小学4年生 2007/04/02-2008/04/01
      } else if (gradeNumber === 10) {
        grade = '小学4年生'

      // 小学5年生 2006/04/02-2007/04/01
      } else if (gradeNumber === 11) {
        grade = '小学5年生'

      // 小学6年生 2005/04/02-2006/04/01
      } else if (gradeNumber === 12) {
        grade = '小学6年生'

      // 中学1年生 2004/04/02-2005/04/01
      } else if (gradeNumber === 13) {
        grade = '中学1年生'

      // 中学2年生 2003/04/02-2004/04/01
      } else if (gradeNumber === 14) {
        grade = '中学2年生'

      // 中学3年生 2002/04/02-2003/04/01
      } else if (gradeNumber === 15) {
        grade = '中学3年生'

      // 高校1年生 2001/04/02-2002/04/01
      } else if (gradeNumber === 16) {
        grade = '高校1年生'

      // 高校2年生 2000/04/02-2001/04/01
      } else if (gradeNumber === 17) {
        grade = '高校2年生'

      // 高校3年生 1999/04/02-2000/04/01
      } else if (gradeNumber === 18) {
        grade = '高校3年生'

      // 大学1年生 1998/04/02-1999/04/01
      } else if (gradeNumber === 19) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門1年生'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門1年生'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大1年生'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専4年生'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門1年生'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学1年生'
        }

      // 大学2年生 1997/04/02-1998/04/01
      } else if (gradeNumber === 20) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年生'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門2年生'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年生'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専5年生'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門2年生'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学2年生'
        }

      // 大学3年生 1996/04/02-1997/04/01
      } else if (gradeNumber === 21) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年生'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学3年生'
        }

      // 大学4年生 1995/04/02-1996/04/01
      } else if (gradeNumber === 22) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学4年生'
        }

      // 大学5年生 1994/04/02-1995/04/01
      } else if (gradeNumber === 23) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学M1'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学5年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学M1'
        }

      // 大学6年生 1993/04/02-1994/04/01
      } else if (gradeNumber === 24) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学M2'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学M2'
        }

      // D1
      } else if (gradeNumber === 25) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学院卒業'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学D1'
        }

      // D2
      } else if (gradeNumber === 26) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学院卒業'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '大学D2'
        }

      // 全員卒業
      } else if (gradeNumber > 26) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学院卒業'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        } else if (self.tutor.school_stage === 9) {
          grade = '大学卒業'
        } else if (self.tutor.school_stage === 10) {
          grade = '専門卒業'
        } else if (self.tutor.school_stage === 11) {
          grade = '博士課程卒業'
        }

      // 未該当
      } else {
        grade = ''
      }
      return grade
    }
  },
  watch: {
    'watch.office_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.tutor.office_id = now.id
      }
    },

    'watch.pref': function (now, old) {
      // console.log(now)
      if (now) {
        this.tutor.pref = now.id
        this.geometry = now.name
      }
    },

    'watch.home_pref': function (now, old) {
      // console.log(now)
      if (now) {
        this.tutor.home_pref = now.id
      }
    },

    'watch.old_grade': function (now, old) {
      // console.log(now)
      if (now) {
        this.tutor.old_grade = now.value
      }
    },

    'watch.school_stage': function (now, old) {
      // console.log(now)
      if (now) {
        this.tutor.school_stage = now.value
      }
    },

    'watch.transportation_car': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.transportation_car = 1
      } else if (now === false) {
        this.tutor.transportation_car = 0
      }
      // console.log(this.tutor.transportation_car)
    },

    'watch.transportation_bike': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.transportation_bike = 1
      } else if (now === false) {
        this.tutor.transportation_bike = 0
      }
      // console.log(this.tutor.transportation_bike)
    },

    'watch.transportation_scooters': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.transportation_scooters = 1
      } else if (now === false) {
        this.tutor.transportation_scooters = 0
      }
      // console.log(this.tutor.transportation_scooters)
    },

    'watch.transportation_bicycle': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.transportation_bicycle = 1
      } else if (now === false) {
        this.tutor.transportation_bicycle = 0
      }
      // console.log(this.tutor.transportation_bicycle)
    },

    'watch.transportation_train': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.transportation_train = 1
      } else if (now === false) {
        this.tutor.transportation_train = 0
      }
      // console.log(this.tutor.transportation_train)
    },

    'watch.transportation_none': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.transportation_none = 1
      } else if (now === false) {
        this.tutor.transportation_none = 0
      }
      // console.log(this.tutor.transportation_none)
    },

    'watch.exam_s': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.exam_s = 1
      } else if (now === false) {
        this.tutor.exam_s = 0
      }
      // console.log(this.tutor.exam_s)
    },

    'watch.exam_c': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.exam_c = 1
      } else if (now === false) {
        this.tutor.exam_c = 0
      }
      // console.log(this.tutor.exam_c)
    },

    'watch.exam_k': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.exam_k = 1
      } else if (now === false) {
        this.tutor.exam_k = 0
      }
      // console.log(this.tutor.exam_k)
    },

    'watch.exam_d': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.exam_d = 1
      } else if (now === false) {
        this.tutor.exam_d = 0
      }
      // console.log(this.tutor.exam_s)
    },

    'watch.experience_tutor': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.experience_tutor = 1
      } else if (now === false) {
        this.tutor.experience_tutor = 0
      }
      // console.log(this.tutor.experience_tutor)
    },

    'watch.experience_cram': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.experience_cram = 1
      } else if (now === false) {
        this.tutor.experience_cram = 0
      }
      // console.log(this.tutor.experience_cram)
    },

    'watch.experience_none': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.experience_none = 1
      } else if (now === false) {
        this.tutor.experience_none = 0
      }
      // console.log(this.tutor.experience_none)
    },

    'watch.training': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.training = 1
      } else if (now === false) {
        this.tutor.training = 0
      }
      // console.log(this.tutor.training)
    },

    'watch.ssk': function (now, old) {
      // console.log(now)
      if (now === true) {
        this.tutor.ssk = 1
      } else if (now === false) {
        this.tutor.ssk = 0
      }
      // console.log(this.tutor.ssk)
    }
  },
  methods: {
    edit: function (tutor) {
      this.watch.office_id = this.offices.filter((office) => {
        return office.id === this.tutor.office_id
      })[0]
      this.watch.pref = this.prefs.filter((pref) => {
        return pref.id === this.tutor.pref
      })[0]
      this.watch.home_pref = this.prefs.filter((pref) => {
        return pref.id === this.tutor.home_pref
      })[0]
      this.watch.old_grade = this.old_grade[this.tutor.old_grade]
      this.watch.school_stage = this.school_stage[this.tutor.school_stage]
      if (this.tutor.transportation_car === 1) { this.watch.transportation_car = true } else { this.watch.transportation_car = false }
      if (this.tutor.transportation_bike === 1) { this.watch.transportation_bike = true } else { this.watch.transportation_bike = false }
      if (this.tutor.transportation_scooters === 1) { this.watch.transportation_scooters = true } else { this.watch.transportation_scooters = false }
      if (this.tutor.transportation_bicycle === 1) { this.watch.transportation_bicycle = true } else { this.watch.transportation_bicycle = false }
      if (this.tutor.transportation_train === 1) { this.watch.transportation_train = true } else { this.watch.transportation_train = false }
      if (this.tutor.transportation_none === 1) { this.watch.transportation_none = true } else { this.watch.transportation_none = false }

      if (this.tutor.exam_s === 1) { this.watch.exam_s = true } else { this.watch.exam_s = false }
      if (this.tutor.exam_c === 1) { this.watch.exam_c = true } else { this.watch.exam_c = false }
      if (this.tutor.exam_k === 1) { this.watch.exam_k = true } else { this.watch.exam_k = false }
      if (this.tutor.exam_d === 1) { this.watch.exam_d = true } else { this.watch.exam_d = false }

      if (this.tutor.experience_tutor === 1) { this.watch.experience_tutor = true } else { this.watch.experience_tutor = false }
      if (this.tutor.experience_cram === 1) { this.watch.experience_cram = true } else { this.watch.experience_cram = false }
      if (this.tutor.experience_none === 1) { this.watch.experience_none = true } else { this.watch.experience_none = false }

      if (this.tutor.training === 1) { this.watch.training = true } else { this.watch.training = false }
      if (this.tutor.ssk === 1) { this.watch.ssk = true } else { this.watch.ssk = false }
      this.edit_id.tutor_id = tutor.id
    },
    cancelTutor: function () {
      this.$store.dispatch('cancelTutor', {
        edit_id: this.edit_id
      })
    },
    patchTutor: function (tutor) {
      this.$store.dispatch('patchTutor', {
        this: this,
        geometry: this.geometry,
        tutor: tutor,
        edit_id: this.edit_id
      })
    },
    getYubin: function (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5 && that.tutor.address1 === '') {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            // console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.pref = { name: '1. 北海道', value: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.pref = { name: '2. 青森県', value: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.pref = { name: '3. 秋田県', value: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.pref = { name: '4. 岩手県', value: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.pref = { name: '5. 山形県', value: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.pref = { name: '6. 宮城県', value: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.pref = { name: '7. 福島県', value: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.pref = { name: '8. 栃木県', value: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.pref = { name: '9. 山梨県', value: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.pref = { name: '10. 群馬県', value: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.pref = { name: '11. 茨城県', value: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.pref = { name: '12. 千葉県', value: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.pref = { name: '13. 埼玉県', value: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.pref = { name: '14. 東京都', value: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.pref = { name: '15. 神奈川県', value: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.pref = { name: '16. 静岡県', value: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.pref = { name: '17. 長野県', value: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.pref = { name: '18. 愛知県', value: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.pref = { name: '19. 岐阜県', value: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.pref = { name: '20. 新潟県', value: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.pref = { name: '21. 富山県', value: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.pref = { name: '22. 石川県', value: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.pref = { name: '23. 福井県', value: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.pref = { name: '24. 滋賀県', value: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.pref = { name: '25. 京都府', value: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.pref = { name: '26. 三重県', value: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.pref = { name: '27. 和歌山県', value: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.pref = { name: '28. 奈良県', value: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.pref = { name: '29. 大阪府', value: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.pref = { name: '30. 兵庫県', value: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.pref = { name: '31. 鳥取県', value: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.pref = { name: '32. 島根県', value: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.pref = { name: '33. 岡山県', value: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.pref = { name: '34. 広島県', value: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.pref = { name: '35. 山口県', value: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.pref = { name: '36. 高知県', value: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.pref = { name: '37. 徳島県', value: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.pref = { name: '38. 香川県', value: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.pref = { name: '39. 愛媛県', value: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.pref = { name: '40. 福岡県', value: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.pref = { name: '41. 佐賀県', value: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.pref = { name: '42. 長崎県', value: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.pref = { name: '43. 熊本県', value: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.pref = { name: '44. 宮崎県', value: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.pref = { name: '45. 大分県', value: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.pref = { name: '46. 鹿児島県', value: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.pref = { name: '47. 沖縄県', value: 47 }
            }
            // that.tutor.pref = data.results[0].address1
            that.tutor.address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    },
    getYubin2: function (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5 && that.tutor.home_address1 === '') {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            // console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.home_pref = { name: '1. 北海道', value: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.home_pref = { name: '2. 青森県', value: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.home_pref = { name: '3. 秋田県', value: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.home_pref = { name: '4. 岩手県', value: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.home_pref = { name: '5. 山形県', value: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.home_pref = { name: '6. 宮城県', value: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.home_pref = { name: '7. 福島県', value: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.home_pref = { name: '8. 栃木県', value: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.home_pref = { name: '9. 山梨県', value: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.home_pref = { name: '10. 群馬県', value: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.home_pref = { name: '11. 茨城県', value: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.home_pref = { name: '12. 千葉県', value: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.home_pref = { name: '13. 埼玉県', value: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.home_pref = { name: '14. 東京都', value: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.home_pref = { name: '15. 神奈川県', value: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.home_pref = { name: '16. 静岡県', value: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.home_pref = { name: '17. 長野県', value: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.home_pref = { name: '18. 愛知県', value: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.home_pref = { name: '19. 岐阜県', value: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.home_pref = { name: '20. 新潟県', value: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.home_pref = { name: '21. 富山県', value: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.home_pref = { name: '22. 石川県', value: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.home_pref = { name: '23. 福井県', value: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.home_pref = { name: '24. 滋賀県', value: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.home_pref = { name: '25. 京都府', value: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.home_pref = { name: '26. 三重県', value: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.home_pref = { name: '27. 和歌山県', value: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.home_pref = { name: '28. 奈良県', value: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.home_pref = { name: '29. 大阪府', value: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.home_pref = { name: '30. 兵庫県', value: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.home_pref = { name: '31. 鳥取県', value: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.home_pref = { name: '32. 島根県', value: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.home_pref = { name: '33. 岡山県', value: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.home_pref = { name: '34. 広島県', value: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.home_pref = { name: '35. 山口県', value: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.home_pref = { name: '36. 高知県', value: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.home_pref = { name: '37. 徳島県', value: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.home_pref = { name: '38. 香川県', value: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.home_pref = { name: '39. 愛媛県', value: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.home_pref = { name: '40. 福岡県', value: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.home_pref = { name: '41. 佐賀県', value: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.home_pref = { name: '42. 長崎県', value: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.home_pref = { name: '43. 熊本県', value: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.home_pref = { name: '44. 宮崎県', value: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.home_pref = { name: '45. 大分県', value: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.home_pref = { name: '46. 鹿児島県', value: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.home_pref = { name: '47. 沖縄県', value: 47 }
            }
            // that.tutor.home_pref = data.results[0].address1
            that.tutor.home_address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.errors {
  color: red;
  font-size: .85rem;
}
.req {
  background: #dffbef;
}
.fa-pencil-square-o {
  margin-right: 5px;
  font-weight: bold;
}
td {
  padding: 0 !important;
  height: 34px;
  input {
    width: 100%;
    font-size: 14px;
    border: none;
    height: 34px;
    &.name_w {
      width: 50%;
    }
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  textarea {
    width: 100%;
    font-size: 14px;
    border: none;
    height: 100px;
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  .calc {
    padding: 8px;
  }
}
.cancel {
  margin-top: 0 !important;
}
.fa-pencil {
  margin-right: 5px;
  font-weight: bold;
}
.checkbox {
  font-size: .85rem;
  color: #333;
  div {
    display: flex;
    label {
      padding-top: 9px;
      padding-left: 5px;
    }
    input {
      height: 29px;
      width: 20px;
    }
  }
}
.m-box__inner {
  height: calc(100vh - 262px);
  overflow-y: scroll;
  border: 1px solid #eee;
}
</style>
<style lang="scss">
.TutorProfile {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: 14px;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// TutorProfile.vue?c7968116